import { useEffect, useState } from "react";
import { getAllUserConnectionStatus } from "../../../services/auth";

export default function useUserConnections() {
  const [isLoading, setIsLoading] = useState(true);
  const [userConnections, setUserConnections] = useState([]);

  const fetchData = async () => {
    const data = await getAllUserConnectionStatus();
    if (data) {
      setUserConnections(data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);
  return {
    isLoading,
    userConnections,
  };
}
